/* external */
import { colors } from "@toddle-edu/ds-theme";

/* internal */
import {
  QUESTION_TYPE_FILL_IN_THE_BLANKS,
  QUESTION_TYPE_MULTIPLE_CHOICE,
  QUESTION_TYPE_TEXT_RESPONSE,
  QUESTION_TYPE_TRUE_OR_FALSE,
  QUESTION_UID_BLANKS,
  QUESTION_UID_MULTI_CHOICE,
  QUESTION_UID_TEXT_RESPONSE_V3,
  QUESTION_UID_TRUE_FALSE_V2,
} from "Worksheet/modules/WorksheetConstants";

export const EMOJI_COLOR_TRAY = [
  colors.pink950,
  colors.orange950,
  colors.green950,
  colors.yellow950,
];

export const DIALOGS_INFO = {
  CLEAR_CHAT: {
    title: ({ t }) => t("classRoom:clear_chat"),
    message: ({ t }) => t("classRoom:clear_chat_history_msg"),
    buttonOneText: ({ t }) => t("common:cancel"),
    buttonTwoText: ({ t }) => t("common:clear"),
  },
  REPLACE_QUESTION: {
    title: ({ t }) =>
      t("common:replace_with_label", { label: t("common:question") }),
    message: ({ t }) =>
      t("worksheet:are_you_sure_you_want_to_replace_your_existing_with_label", {
        label: t("common:question"),
      }),
    buttonOneText: ({ t }) => t("common:cancel"),
    buttonTwoText: ({ t }) => t("common:replace"),
    isDoNotShowAgainPopupVisible: true,
  },
  REPLACE_ASSESSMENT_TOOL: {
    title: ({ t }) =>
      t("common:replace_with_label", {
        label: t("common:le_assessmentTool_label"),
      }),
    message: ({ t }) =>
      t("worksheet:are_you_sure_you_want_to_replace_your_existing_with_label", {
        label: t("common:le_assessmentTool_label"),
      }),
    buttonOneText: ({ t }) => t("common:cancel"),
    buttonTwoText: ({ t }) => t("common:replace"),
    isDoNotShowAgainPopupVisible: true,
  },
};

export const INTERDISCIPLINARY_FIELD_MAPPING = {
  learningStandardMYP: "disciplinaryLearningStandardMYP",
  objectivesMYP: "disciplinaryObjectivesMYP",
  relatedConceptsMYP: "disciplinaryRelatedConceptsMYP",
  content: "disciplinaryContent",
};

export const LOCAL_CONTEXT = ["location", "textTitles", "twoTextTitles"];
export const MYP_OBJECTIVES = ["objectivesMYP", "interdisciplinaryCriteriaMYP"];

export const LOCATION = "location";
export const TEXT_TITLES = "textTitles";
export const TWO_TEXT_TITLES = "twoTextTitles";

export const ELEMENT_TYPE_ADD_LEARNING_GOALS = "AddLearningGoals";

// * Prompt actions
export const CONVERT_QUESTION_FORMAT = "convert_question_format";
export const INCREASE_DIFFICULTY = "increase_difficulty";
export const DECREASE_DIFFICULTY = "decrease_difficulty";
export const GENERATE_SIMILAR_QUESTIONS = "generate_similar_questions";
export const INCLUDE_REAL_WORLD_EXAMPLES = "include_real_world_examples";

export const GENERATE_QUESTIONS = "generate_questions";

// * Prompt group type
export const ASSESSMENT_TOOL = "ASSESSMENT_TOOL";

// * Prompt field type

// * Enhance prompts dropdown label style
export const ENHANCE_DROPDOWN_LABEL_STYLE = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

// * used for send question type to AI
export const QUESTION_TYPE_UID_VALUE_MAPPING = {
  [QUESTION_UID_TEXT_RESPONSE_V3]: QUESTION_TYPE_TEXT_RESPONSE,
  [QUESTION_UID_MULTI_CHOICE]: QUESTION_TYPE_MULTIPLE_CHOICE,
  [QUESTION_UID_BLANKS]: QUESTION_TYPE_FILL_IN_THE_BLANKS,
  [QUESTION_UID_TRUE_FALSE_V2]: QUESTION_TYPE_TRUE_OR_FALSE,
};

// * context fields CF - Context field
export const CF_NEW_QUESTION_TYPE = "newQuestionType";
export const CF_TYPE_OF_QUESTION = "typeOfQuestions";
export const CF_QUESTION_TEXT = "questionText";
export const CF_MYP_CONTENT = "mypContent";

export const WS_AI_SETTING_FLAGS = {
  HIDE_REPLACE_QUESTION_DIALOGUE: "HideReplaceQuestionDialogue",
  HIDE_REPLACE_ASSESSMENT_TOOL_DIALOGUE: "HideReplaceAssessmentToolDialogue",
};

export const WS_AI_ASSESSMENT_TOOLS_MAPPING = {
  RUBRIC: "common:rubric",
  SINGLE_POINT_RUBRIC: "common:single_point_rubric",
  CHECKLIST: "common:checklist",
  MYP_CRITERIA: "common:criteria_rubric",
  MYP_OBJECTIVE_RUBRIC: "common:criteria_rubric",
};
